/**
 * #1857 (audit B18) — de uitleg bij een abonnementslimiet: wat er niet kon, wat er wél
 * blijft, en wat de gebruiker kan doen. Zonder dit zag een gebruiker wiens proef net
 * voorbij was "Je hebt geen bewerkrechten", en dacht hij dat zijn project kapot was.
 */
export interface TierLimiet {
  kind?: 'people' | 'projects' | 'collaborators' | 'media' | 'feature' | string;
  limit?: number;
  requiredTier?: string;
  role?: string;
}

type Vertaal = (key: string, params?: Record<string, string>) => string;

const mb = (bytes: number) => `${Math.round(bytes / (1024 * 1024))} MB`;

export function limietUitleg(l: TierLimiet, t: Vertaal): string {
  const limit = typeof l.limit === 'number' ? l.limit : undefined;
  switch (l.kind) {
    case 'people':
      return t('limietUitleg_people', { limit: String(limit ?? 250) });
    case 'projects':
      return t('limietUitleg_projects', { limit: String(limit ?? 1) });
    case 'collaborators':
      return t(l.role === 'editor' ? 'limietUitleg_editors' : 'limietUitleg_viewers', {
        limit: String(limit ?? 0),
      });
    case 'media':
      return t('limietUitleg_media', { limit: limit ? mb(limit) : '50 MB' });
    default:
      return t('limietUitleg_feature');
  }
}
